import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import { onMounted } from 'vue';
import steps from './steps';
export default {
  __name: 'index',
  setup(__props) {
    let driver = null;
    onMounted(() => {
      initDriver();
    });
    const initDriver = () => {
      driver = new Driver({
        animate: true,
        // 禁止点击蒙版关闭
        allowClose: false,
        closeBtnText: '关闭',
        nextBtnText: '下一个',
        prevBtnText: '上一个'
      });
    };
    // 语言切换时，重新初始化 Driver

    const onClick = () => {
      driver.defineSteps(steps());
      driver.start();
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_tooltip, {
        content: "导航"
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          id: "guide-start",
          icon: "guide",
          onClick: onClick
        })]),
        _: 1
      })]);
    };
  }
};